import React from 'react'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import T from 'T'

const CancelButton = ({ size = 'small', label = T.CANCEL, onClick = noop, ...rest }) => {
  return (
    <Button onClick={onClick} variant="text" size={size} color="textSecondary" {...rest}>
      {label}
    </Button>
  )
}

CancelButton.propTypes = {
  size: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
}

export default CancelButton
